<template>
  <Popup :show="show">
    <div class="tips-pop">
      <SvgIcon icon-class="close" class-name="close" @click.native="handleClose"></SvgIcon>
      <div class="content">
        <p>提现功能加紧完善中，预计1月25日12点后开放，请耐心等待。</p>
        <p>提现功能上线前，您的账户收入和消费都可正常使用，不受影响</p>
      </div>
    </div>
  </Popup>
</template>

<script>
import Popup from '@/components/Popup'
import SvgIcon from '@/components/SvgIcon'
export default {
  name: 'TipsPop',
  props: {
    show: Boolean,
  },
  components: {
    Popup,
    SvgIcon
  },
  model: {
    prop: 'show',
    event: 'change'
  },
  methods: {
    handleClose () {
      this.$emit('change', false)
    }
  }
}
</script>
<style lang="scss" scoped>
.tips-pop {
  position: relative;
  background: #fff;
  border-radius: 20px;
  padding: 50px 55px;
  width: 500px;
  .close {
    font-size: 32px;
    position: absolute;
    top: 14px;
    right: 14px;
  }
  .content {
    font-size: 28px;
    line-height: 50px;
  }
}
</style>
